import { render, staticRenderFns } from "./security-upgrade.vue?vue&type=template&id=230a80e8"
import script from "./security-upgrade.vue?vue&type=script&lang=js"
export * from "./security-upgrade.vue?vue&type=script&lang=js"
import style0 from "./security-upgrade.vue?vue&type=style&index=0&id=230a80e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports